// 题库术语白话表（新手化 · §0 视觉点词释义）。
// 命中题干/选项/解析里的术语 → 渲染为可点 chip，点出白话。
// gloss 文本统一取自 poker-terms-zh 的 AUTHORITATIVE_GLOSS（单一权威，杜绝多本词典冲突）；
// 本文件只保留「哪些术语要在 quiz 内联里点词」的选取清单，不另写 gloss。
// 选取保守：仅「GTO/缩写 + 手牌读牌 + 位置代码」三类；不含 4 个基本动作动词（过牌/下注/加注/弃牌）以免过噪。
import { authoritativeGloss, type GlossEntry } from "./poker-terms-zh";

export type { GlossEntry };

const QUIZ_GLOSS_TERMS: readonly string[] = [
  // —— GTO / 缩写 / 策略 ——
  "check-raise", "过牌-加注", "过牌加注", "c-bet", "cbet", "donk", "squeeze", "isolate",
  "overbet", "超池", "OOP", "IP", "3bet", "4bet", "SPR", "MDF", "ICM", "EV", "Outs",
  "所罗门", "范围", "range", "尺度", "sizing", "频率", "权益", "equity", "隐含赔率",
  "弃牌率", "极化", "混合策略", "后门", "阻塞", "blocker", "两头顺",
  // —— 位置代码（新手常不认识缩写）——
  "UTG", "HJ", "CO", "BTN", "SB", "BB", "MP",
  // —— 手牌读牌 / 牌面 ——
  "顶对", "两对", "三条", "set", "坚果", "nuts", "听牌", "抽花", "抽顺",
  "公对", "天花", "天顺", "盖帽", "赔率",
];

export const QUIZ_GLOSS: GlossEntry[] = QUIZ_GLOSS_TERMS.flatMap((term) => {
  const gloss = authoritativeGloss(term);
  return gloss ? [{ term, gloss }] : [];
});

const isAscii = (s: string): boolean => /^[a-zA-Z0-9-]+$/.test(s);

// 长词优先，避免短词在同一位置抢先匹配
const SORTED = [...QUIZ_GLOSS].sort((a, b) => b.term.length - a.term.length);

const GLOSS_MAP = new Map<string, string>(
  SORTED.map((e) => [e.term.toLowerCase(), e.gloss]),
);

const PATTERN_SRC = SORTED.map((e) => {
  const esc = e.term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return isAscii(e.term) ? `\\b${esc}\\b` : esc;
}).join("|");

const PATTERN_FLAGS = "gi";

// 每次返回新 RegExp，避免全局正则 lastIndex 在调用间串状态
export function glossRegex(): RegExp {
  return new RegExp(PATTERN_SRC, PATTERN_FLAGS);
}

export function glossFor(matched: string): string | undefined {
  return GLOSS_MAP.get(matched.toLowerCase());
}
